import { Link } from '@tanstack/react-router';
import { forwardRef } from 'react';

/**
 * RouterLink component for compatibility with existing code.
 * Wraps TanStack Router's Link component with a Next.js-like API.
 */
interface RouterLinkProps {
  href: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  target?: string;
  rel?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  [key: string]: any;
}

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  ({ href, children, ...props }, ref) => {
    // Handle external links
    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:')) {
      return (
        <a href={href} ref={ref} {...props}>
          {children}
        </a>
      );
    }

    return (
      <Link to={href} ref={ref} {...props}>
        {children}
      </Link>
    );
  }
);

RouterLink.displayName = 'RouterLink';

export { RouterLink };
export default RouterLink;
